"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDestinationVGeoBySRegion = exports.getDestinationVDCBySRegion = exports.getDestinationVRegionBySRegion = exports.getRegionIDC = exports.IDCRegion = exports.ClientBuildRegion = exports.SCMBuildRegion = exports.DeploymentVDC = exports.DeploymentVRegion = exports.DeploymentVGeo = exports.RegionDisplayMap = exports.Region = void 0;
/**
 * ISO 639-1 Language Code
 *
 * lower case
 */
var Region;
(function (Region) {
    Region["jp"] = "jp";
    Region["th"] = "th";
    Region["my"] = "my";
    Region["id"] = "id";
    Region["ph"] = "ph";
    Region["vn"] = "vn";
    Region["us"] = "us";
    Region["gb"] = "gb";
    Region["sg"] = "sg";
    Region["au"] = "au";
    Region["ca"] = "ca";
    Region["nz"] = "nz";
})(Region = exports.Region || (exports.Region = {}));
exports.RegionDisplayMap = {
    [Region.jp]: '日本',
    [Region.th]: 'ไทย',
    [Region.my]: 'Malaysia',
    [Region.id]: 'Indonesia',
    [Region.vn]: 'Việt Nam',
    [Region.us]: 'US',
    [Region.gb]: 'UK',
    [Region.sg]: 'Singapore',
    [Region.ph]: 'Philippines',
    [Region.au]: 'Australia',
    [Region.ca]: 'Canada',
    [Region.nz]: 'New Zealand',
};
var DeploymentVGeo;
(function (DeploymentVGeo) {
    DeploymentVGeo["US"] = "US";
    DeploymentVGeo["ROW"] = "ROW";
})(DeploymentVGeo = exports.DeploymentVGeo || (exports.DeploymentVGeo = {}));
var DeploymentVRegion;
(function (DeploymentVRegion) {
    DeploymentVRegion["US_TTP"] = "US-TTP";
    DeploymentVRegion["US_TTP2"] = "US-TTP2";
    DeploymentVRegion["US_EAST"] = "US-East";
    DeploymentVRegion["SG_CENTRAL"] = "Singapore-Central";
})(DeploymentVRegion = exports.DeploymentVRegion || (exports.DeploymentVRegion = {}));
var DeploymentVDC;
(function (DeploymentVDC) {
    DeploymentVDC["USEAST5"] = "useast5";
    DeploymentVDC["USEAST8"] = "useast8";
    DeploymentVDC["MALIVA"] = "maliva";
    DeploymentVDC["SG1"] = "sg1";
    DeploymentVDC["MY"] = "my";
    DeploymentVDC["MY2"] = "my2";
})(DeploymentVDC = exports.DeploymentVDC || (exports.DeploymentVDC = {}));
var SCMBuildRegion;
(function (SCMBuildRegion) {
    SCMBuildRegion["CN"] = "cn";
    SCMBuildRegion["OCI"] = "oci";
})(SCMBuildRegion = exports.SCMBuildRegion || (exports.SCMBuildRegion = {}));
var ClientBuildRegion;
(function (ClientBuildRegion) {
    ClientBuildRegion["VA"] = "va";
    ClientBuildRegion["SG"] = "sg";
    ClientBuildRegion["OCI"] = "oci";
})(ClientBuildRegion = exports.ClientBuildRegion || (exports.ClientBuildRegion = {}));
/**
 * @deprecated not compatible with TTP
 */
var IDCRegion;
(function (IDCRegion) {
    IDCRegion["VA"] = "va";
    IDCRegion["SG"] = "sg";
})(IDCRegion = exports.IDCRegion || (exports.IDCRegion = {}));
/**
 * @deprecated not compatible with TTP
 */
const getRegionIDC = (region) => {
    return [Region.jp, Region.us, Region.gb].includes(region) ? IDCRegion.VA : IDCRegion.SG;
};
exports.getRegionIDC = getRegionIDC;
const getDestinationVRegionBySRegion = (region) => {
    switch (region) {
        case Region.us:
            return DeploymentVRegion.US_TTP;
        case Region.sg:
        case Region.th:
        case Region.id:
        case Region.my:
        case Region.vn:
        case Region.au:
        case Region.nz:
            return DeploymentVRegion.SG_CENTRAL;
        case Region.jp:
        case Region.ca:
        default:
            return DeploymentVRegion.US_EAST;
    }
};
exports.getDestinationVRegionBySRegion = getDestinationVRegionBySRegion;
const getDestinationVDCBySRegion = (region) => {
    switch (region) {
        case Region.us:
            return DeploymentVDC.USEAST5;
        case Region.sg:
        case Region.th:
        case Region.id:
        case Region.my:
        case Region.vn:
        case Region.au:
        case Region.nz:
            return DeploymentVDC.SG1;
        case Region.jp:
        case Region.ca:
        default:
            return DeploymentVDC.MALIVA;
    }
};
exports.getDestinationVDCBySRegion = getDestinationVDCBySRegion;
const getDestinationVGeoBySRegion = (region) => {
    switch (region) {
        case Region.us:
            return DeploymentVGeo.US;
        case Region.sg:
        case Region.th:
        case Region.id:
        case Region.my:
        case Region.vn:
        case Region.jp:
        case Region.ca:
        case Region.au:
        case Region.nz:
        default:
            return DeploymentVGeo.ROW;
    }
};
exports.getDestinationVGeoBySRegion = getDestinationVGeoBySRegion;
